export default __webpack_public_path__ + "static/media/EU-green-bond-standard.41e30aa4.jpg";